import React, { useEffect, useState } from "react"
import { Button, Col, Form, Modal, Row } from "react-bootstrap"
import { useTranslation } from "react-i18next"
import shortId from "shortid"

interface selectedItems {
    id: number
}

const CreateParcelModal = ({
    show,
    setShow,
    parcel,
    handleCreateParcel
}: {
    show: string
    setShow: Function
    parcel: Record<string, any>
    handleCreateParcel: Function
}) => {
    const { t } = useTranslation()
    const [parcelItems, setParcelItems] = useState([] as Record<string, any>[])
    const [selectedItems, setSelectedItems] = useState([] as selectedItems[])

    useEffect(() => {
        setParcelItems([...(parcel?.ParcelItems || [])])
    }, [JSON.stringify(parcel?.ParcelItems)])

    return (
        <Modal
            size="xl"
            show={show === "createParcelModal"}
            onHide={() => {
                setSelectedItems([])
                setParcelItems([])
                setShow("")
            }}
            backdrop="static"
            keyboard={false}>
            <Modal.Header closeButton>
                <Modal.Title className="text-uppercase">{`Move & Create Parcel : ${parcel?.uuid}`}</Modal.Title>
            </Modal.Header>
            <Modal.Body className="consolidation-modal bg-light">
                <Row className="d-flex justify-content-around">
                    <Col lg={12} className="scrollable">
                        <Form>
                            <Form.Group>
                                <Row className="bg-transparent border custom-thead py-2 mx-2 rounded text-uppercase">
                                    <Col xs={1}>
                                        <Form.Check
                                            type="checkbox"
                                            onChange={(e: any) => {
                                                if (e.target.checked) {
                                                    setSelectedItems([...parcelItems?.map((cp) => cp.id)])
                                                } else {
                                                    setSelectedItems([])
                                                }
                                            }}
                                        />
                                    </Col>
                                    <Col xs={3}>{t("Parcel ID")}</Col>
                                    <Col xs={3}>{t("Item")}</Col>
                                    <Col xs={1}>{t("Qty")}</Col>
                                    <Col xs={2}>{t("Value")}</Col>
                                    <Col xs={2}>{t("Location")}</Col>
                                </Row>
                                {parcelItems?.map((item: Record<string, any>, index: number) => (
                                    <Row
                                        key={shortId.generate()}
                                        id={shortId.generate()}
                                        className={`py-2 rounded bg-white my-2 mx-2`}>
                                        <Col lg={1}>
                                            <Form.Check
                                                type="checkbox"
                                                checked={!!selectedItems?.find((i) => i === item.id)}
                                                label={item.uuid}
                                                value={item.uuid}
                                                className={"primary-text"}
                                                onChange={(e: any) => {
                                                    if (e.target.checked) {
                                                        setSelectedItems([...selectedItems, item.id])
                                                    } else {
                                                        setSelectedItems(
                                                            selectedItems?.filter(
                                                                (i: selectedItems) => i?.id !== item?.id
                                                            )
                                                        )
                                                    }
                                                }}
                                            />
                                        </Col>
                                        <Col lg={3} className="">
                                            <span className="">{parcel?.uuid}</span>
                                        </Col>
                                        <Col lg={3} className="">
                                            <span className="">{`${item?.item_name?.substring(0, 50)}...`}</span>
                                        </Col>
                                        <Col lg={1} className="">
                                            <span className="">{`$ ${item?.quantity}`}</span>
                                        </Col>
                                        <Col lg={2} className="">
                                            <span className="">{`$ ${item?.amount}`}</span>
                                        </Col>
                                        <Col lg={2} className={"text-end"}>
                                            <span className="">{`${item?.FulfillmentSuite?.suite}`}</span>
                                        </Col>
                                    </Row>
                                ))}
                            </Form.Group>
                        </Form>
                    </Col>
                </Row>
            </Modal.Body>
            <Modal.Footer>
                <Button
                    disabled={
                        selectedItems.length < parcel?.ParcelItems?.length || parcel?.ParcelItems?.length === 0
                    }
                    onClick={() => handleCreateParcel(parcel.id)}
                    className={"primary-bg"}>
                    {t("Create Parcel")}
                </Button>
            </Modal.Footer>
        </Modal>
    )
}

export default CreateParcelModal
